var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"6"}},[_c('CodeDisplay',{attrs:{"items":_vm.sources}})],1),_vm._t("insideRow")],2)],1),_vm._t("outsideRow")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }